import { IconPresentationProps } from "@insite/mobius/Icon";
import React from "react";

const ChevronDown: React.FC<IconPresentationProps> = props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" fill="none" viewBox="0 0 12 7">
            <path stroke="#636363" strokeLinecap="round" strokeLinejoin="round" d="M.996.766l5 4.743 5-4.743"></path>
        </svg>
    );
};

export default React.memo(ChevronDown);
